import type { TokenInfo } from '@/config/tokens';
import { type PropsWithChildren, createContext, useContext, useState } from 'react';
export type DepositContextProps = {
  activeTab: TokenInfo['symbol'] | 'other' | 'crypto';
  setActiveTab: (tab: string) => void;
};
const DepositContext = createContext<DepositContextProps | null>(null);
export const DepositProvider: React.FC<PropsWithChildren> = ({
  children
}) => {
  const [activeTab, setActiveTab] = useState<string>('USDT');
  return <DepositContext.Provider value={{
    activeTab,
    setActiveTab
  }}>
      {children}
    </DepositContext.Provider>;
};
export const useDeposit = () => {
  const context = useContext(DepositContext);
  if (!context) {
    throw new Error('useDeposit must be used within a DepositProvider');
  }
  return context;
};